import { useState, useCallback } from 'react';

export const useAddCriteriaMenu = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const handleAddCriteriaClick = useCallback(event => {
    setMenuAnchorEl(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    setMenuAnchorEl(null);
  }, []);

  return {
    menuAnchorEl,
    handleAddCriteriaClick,
    handleMenuClose
  };
};

export default useAddCriteriaMenu;
